import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	itemCycleTime: {
		id: 'spa-apps-sidebar-next-gen.menu.reports.devops-reports.item-cycle-time',
		defaultMessage: 'Cycle time report',
		description: 'Cycle time report link item.',
	},
	itemDeploymentFrequency: {
		id: 'spa-apps-sidebar-next-gen.menu.reports.devops-reports.item-deployment-frequency',
		defaultMessage: 'Deployment frequency report',
		description: 'Deployment frequency report link item.',
	},
});
